import * as React from "react";
import "./static/Profile.scss";
import { Button, Paper, Snackbar, TextField } from 'react-md';
import { IUser } from "src/model/ModelTypes";
import { observer } from "mobx-react";
import { IServicesProvider } from "src/di/IServicesProvider";
import { action, observable, computed, runInAction } from "mobx";
import { flatMap, first } from "rxjs/operators";
export class ProfileViewModel {
    @observable serviceProvider: IServicesProvider;
    @observable user: IUser;
    @observable typedName: string;
    @observable typedEmail: string;
    @observable typedUsername: string;
    @observable typedCurrentPassword: string;
    @observable typedNewPassword: string = "";
    @observable typedConfirmNewPassword: string = "";
    @observable passwordHasError: boolean = false;
    @observable currentPasswordError: boolean = false;
    @observable nameHasError: boolean = false;
    @observable toasts: string[] = [];
    @observable asyncOperationsCount = 0;
    @observable errorMessages: string[] = [];

    // Set the value of disabled={} as a boolean, so it can change state
    @computed get saveEnabled(): boolean {
        return this.asyncOperationsCount === 0 &&
        ((this.typedName === this.user.name) || (!this.nameHasError))
        && (
            (
                this.typedConfirmNewPassword === ""
                && this.typedCurrentPassword === ""
                && this.typedNewPassword === ""
            ) ||
            (!this.currentPasswordError && !this.passwordHasError)
        );
    }  

    @action.bound
    setServicesProvider(serviceProvider: IServicesProvider) {
        this.serviceProvider = serviceProvider;
        this.user = this.serviceProvider.getUser();
        this.typedName = this.user.name;
        this.typedEmail = this.user.email;
        this.typedUsername = this.user.username.split("-")[1];
    }

    @action.bound
    setToast(message: string = 'Account information updated') {
        this.toasts.push(message);
    }
    @action.bound
    dismissToast() {
        this.toasts.splice(0, this.toasts.length);
    }
    @action.bound
    onSaveClicked() {
        if (this.user.name !== this.typedName) {
            this.user.name = this.typedName;
        }
        if (this.typedNewPassword !== "" 
        && !this.passwordHasError 
        && this.typedConfirmNewPassword !== "") {
            this.user.password = this.typedNewPassword;
        }
        this.asyncOperationsCount += 1;
        this.serviceProvider.getUserProfileOperations()
        .pipe(
            first(),
            flatMap(
                operations => operations.editProfile(this.user)
            )
        )
        .subscribe(
            result => {
                this.setToast();
                runInAction(() => {
                    this.errorMessages.splice(0, this.errorMessages.length);
                    this.asyncOperationsCount = 0;
                });
            },
            error => {
                runInAction(() => {
                    this.asyncOperationsCount = 0;
                    this.errorMessages.splice(0, this.errorMessages.length);
                    this.errorMessages.push(error.message);
                });
            }
        );
    }
}

@observer class ProfileView extends React.Component< { model: ProfileViewModel } , {} > {

    render() {
        return (
            <div className="ProfileRoot GeneralViewContainer">
            
                <div className="AccountGeneralInfo">
                    <h1>{this.props.model.user.name}</h1>
                    <h3><span>Organisation</span>{this.props.model.user.organisationName}</h3>
                    <h3><span>Role</span>{this.props.model.user.role.name}</h3>
                </div>  

                <div className="row">
                    <div className="ProfilePaperContainer AccountDetails">
                        <h2>Account Details</h2>
                        <Paper
                            zDepth={2}
                            className='md-grid'
                        >
                            <div
                                className='md-cell'
                            >
                                <h4>Name</h4>
                                <TextField
                                    id="floating-center-title"
                                    lineDirection="left"
                                    value={this.props.model.typedName}
                                    error={this.props.model.nameHasError}
                                    errorText="Invalid Name"
                                    onChange={
                                        (e) => {
                                            this.props.model.typedName = e.toString();
                                            this.props.model.nameHasError = 
                                            !this.props.model.serviceProvider.getInputValidator().isValidName(
                                                this.props.model.typedName
                                            );
                                            }
                                    }
                                />
                            </div>
                            <div
                                className='md-cell'
                            >
                                <h4>Username</h4>
                                <TextField
                                    id="username"
                                    value={this.props.model.typedUsername}
                                    disabled={true}
                                />
                            </div>

                        </Paper>
                    </div>
                </div>

                <div className="row">
                    <div className="ProfilePaperContainer SecurityInformation">
                        <h2>Security Information</h2>
                        <Paper
                            zDepth={2}
                            className='md-grid'
                        >
                            <div
                                className='md-cell'
                            >
                                <h4>Current password</h4>
                                <TextField
                                    id="current-password"
                                    type="password"

                                    onChange={
                                        (e) => {
                                            this.props.model.typedCurrentPassword = e.toString();
                                        }
                                    }
                                />
                            </div>
                            <div
                                className='md-cell'
                            >
                                <h4>Email</h4>
                                <TextField
                                    id="email"
                                    value={this.props.model.typedEmail}
                                    disabled={true}
                                />
                            </div>
                            <div
                                className='md-cell'
                            >
                                <h4>New Password</h4>
                                <TextField
                                    id="new-password"
                                    type="password"
                                    error={this.props.model.passwordHasError}
                                    errorText="Invalid Password"
                                    onChange={
                                        (e) => {
                                            this.props.model.typedNewPassword = e.toString();
                                            this.props.model.passwordHasError = !this.props
                                            .model
                                            .serviceProvider
                                            .getInputValidator()
                                            .isValidPassword(e.toString());
                                            }
                                    }
                                />
                            </div>
                            <div
                                className='md-cell'
                            >
                                <h4>Confirm new password</h4>
                                <TextField
                                    id="confirm-password"
                                    type="password"
                                    error={this.props.model.passwordHasError}
                                    errorText="Invalid Password"
                                    onChange={
                                        (e) => {
                                            this.props.model.typedConfirmNewPassword = e.toString();

                                            this.props.model.passwordHasError = !this.props
                                            .model
                                            .serviceProvider
                                            .getInputValidator()
                                            .isValidPassword(e.toString())
                                            && e.toString() === this.props.model.typedNewPassword;
                                        }
                                    }
                                />
                            </div>
                        </Paper>
                    </div>
                </div>

                <Button 
                    raised={true}
                    secondary={true}
                    disabled={!this.props.model.saveEnabled}
                    onClick={this.props.model.onSaveClicked}
                >
                Save Changes
                </Button>
                    <Snackbar
                        id="notifications-snackbar"
                        toasts={this.props.model.toasts.map(item => {
                            return {
                                text: item
                            };
                        })}
                        autohide={true}
                        onDismiss={this.props.model.dismissToast}
                    />
                    <Snackbar
                        id="errors-snackbar"
                        toasts={this.props.model.errorMessages.map(item => {
                            return {
                                text: item
                            };
                        })}
                        autohide={true}
                        onDismiss={() => {
                            this.props.model.errorMessages = [];
                        }
                        }
                    />
            </div>
        );
    }
}

export default ProfileView;


// WEBPACK FOOTER //
// ./src/view/Profile/Profile.tsx